<script setup lang="ts">
</script>
<template>
    <div class="component-portlet">
        <div class="portlet-header">
            <slot name="header"></slot>
        </div>
        <div class="content">
            <slot></slot>
        </div>
    </div>
</template>
